import { Locales } from "../../app";
import { dayjsLocaleLoaders } from "./dayjsLocales";

export const getLocaleByLanguage = (language: string): Locales => {
  switch (language?.toLowerCase()) {
    case "en":
      return Locales.EN;
    case "nl":
      return Locales.NL;
    case "fr":
      return Locales.FR;
    case "be":
      return Locales.BE;
    case "bg":
      return Locales.BG;
    case "bn":
      return Locales.BN;
    case "bo":
      return Locales.BO;
    case "br":
      return Locales.BR;
    case "bs":
      return Locales.BS;
    case "ca":
      return Locales.CA;
    case "cs":
      return Locales.CS;
    case "cv":
      return Locales.CV;
    case "cy":
      return Locales.CY;
    case "de":
      return Locales.DE;
    case "it":
      return Locales.IT;
    case "es":
      return Locales.ES;
    case "pl":
      return Locales.PL;
    case "pt":
      return Locales.PT;
    case "ro":
      return Locales.RO;
    case "ru":
      return Locales.RU;
    case "zh":
      return Locales.ZH;
    default:
      return Locales.EN;
  }
};

export const getValidLocaleForBrowser = async (userLanguage: string) => {
  const browserLocale = getLocaleByBrowser().toLowerCase();

  if (supportedLocales.includes(browserLocale)) {
    await importDayjsLocale(browserLocale);
    return browserLocale;
  }

  if (!browserLocale.includes("-")) {
    return getLocaleByLanguage(userLanguage);
  }

  const localeWithoutDash = browserLocale.split("-")[0];
  if (supportedLocales.includes(localeWithoutDash)) {
    await importDayjsLocale(localeWithoutDash);
    return localeWithoutDash;
  }

  return getLocaleByLanguage(userLanguage);
};

const getLocaleByBrowser = () => {
  if (navigator.languages && navigator.languages.length) {
    return navigator.languages[0];
  }

  return navigator.language;
};

const importDayjsLocale = async (locale: string) => {
  await dayjsLocaleLoaders[locale]?.();
};

// Single source of truth: the locales dayjs actually ships loaders for.
const supportedLocales = Object.keys(dayjsLocaleLoaders);
